import { Dropdown } from 'antd';
import cx from 'clsx';

const DropdownAntd = (props) => {
  const {
    value,
    items,
    placement = 'bottomLeft',
    trigger = ['hover'],
    overlayStyle,
    onClick,
    onVisibleChange = () => {},
    open,
    setOpen,
    className,
    disableHover,
    ...rest
  } = props;

  const handleClick = (e) => {
    e.stopPropagation();
    !onClick ? setOpen(!open) : onClick();
  };

  return (
    <Dropdown
      menu={{
        items,
      }}
      trigger={trigger}
      onClick={handleClick}
      placement={placement}
      open={props?.open}
      overlayStyle={overlayStyle}
      onOpenChange={onVisibleChange}
      overlayClassName={cx(className)}
      {...rest}
    >
      {value}
    </Dropdown>
  );
};

export default DropdownAntd;
